<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 194.461"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M87.999 37.409c0.043,3.718 -0.17,6.282 -0.981,8.547 -9.031,-1.859 -17.632,-3.221 -25.804,-4.087 -3.417,-6.487 -3.081,-15.033 1.011,-25.639 4.771,-1.265 9.685,-3.579 14.738,-6.944 2.241,1.196 4.205,3.12 5.891,5.684 1.687,2.565 3.096,5.771 3.95,9.809 0.854,4.039 1.152,8.912 1.195,12.63z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M62.225 16.23c-4.092,10.606 -4.428,19.152 -1.011,25.639 -8.335,-0.883 -16.222,-1.25 -23.663,-1.1 2.933,-8.49 3.863,-17.345 2.792,-26.564 6.931,3.379 14.225,4.054 21.882,2.025z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M62.225 16.23c-7.657,2.029 -14.951,1.354 -21.882,-2.025 -3.605,-1.756 -7.111,-4.244 -10.519,-7.462 1.602,-0.662 3.438,-1.09 5.445,-0.94 2.006,0.149 4.184,0.876 5.956,1.496 1.772,0.619 3.138,1.132 5.059,1.56 1.922,0.427 4.398,0.769 6.789,0.876 2.392,0.107 4.697,-0.021 6.17,-0.428 1.473,-0.406 2.114,-1.09 3.715,-1.496 1.601,-0.405 4.162,-0.534 6.703,-0.363 2.54,0.171 5.06,0.641 7.302,1.838 -5.053,3.365 -9.967,5.679 -14.738,6.944z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M40.343 14.205c1.071,9.219 0.141,18.074 -2.792,26.564 -8.665,0.174 -16.724,1.048 -24.178,2.623 -0.207,-0.849 -0.367,-1.743 -0.477,-2.67 -0.385,-3.227 -0.172,-6.86 0.384,-9.745 0.554,-2.885 1.451,-5.022 2.562,-7.459 1.109,-2.436 2.433,-5.171 4.077,-7.608 1.644,-2.436 3.607,-4.572 5.273,-6.089 1.665,-1.518 3.031,-2.415 4.632,-3.078 3.408,3.218 6.914,5.706 10.519,7.462z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M37.551 40.769c7.441,-0.15 15.328,0.217 23.663,1.1 8.172,0.866 16.773,2.228 25.804,4.087 -0.341,0.95 -0.786,1.847 -1.278,2.671 -0.682,1.142 -1.453,2.143 -2.16,2.95 -1.217,1.389 -2.241,2.202 -5.806,2.672 -3.566,0.469 -9.671,0.598 -15.222,0.405 -5.551,-0.192 -10.546,-0.704 -14.624,-1.111 -4.078,-0.406 -7.237,-0.705 -11.506,-0.812 -4.27,-0.107 -9.65,-0.021 -13.365,-0.513 -2.717,-0.359 -4.542,-1.027 -5.92,-2.12 -0.506,-0.402 -0.952,-0.862 -1.359,-1.384 -1.081,-1.386 -1.89,-3.217 -2.405,-5.322 7.454,-1.575 15.513,-2.449 24.178,-2.623z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M15.807 23.518c1.111,-2.436 2.436,-5.171 4.082,-7.608 1.645,-2.436 3.61,-4.572 5.278,-6.089 1.666,-1.518 3.034,-2.415 4.637,-3.078 1.603,-0.662 3.441,-1.09 5.449,-0.94 2.009,0.149 4.189,0.876 5.963,1.496 1.773,0.619 3.141,1.132 5.064,1.56 1.924,0.427 4.403,0.769 6.796,0.876 2.394,0.107 4.701,-0.021 6.176,-0.428 1.474,-0.406 2.116,-1.09 3.718,-1.496 1.603,-0.405 4.167,-0.534 6.71,-0.363 2.543,0.171 5.065,0.641 7.309,1.838 2.244,1.196 4.209,3.12 5.898,5.684 1.688,2.565 3.099,5.771 3.953,9.809 0.855,4.039 1.154,8.912 1.197,12.63 0.043,3.718 -0.171,6.282 -0.983,8.547 -0.812,2.266 -2.223,4.232 -3.44,5.621 -1.219,1.389 -2.244,2.202 -5.813,2.672 -3.569,0.469 -9.681,0.598 -15.237,0.405 -5.556,-0.192 -10.557,-0.704 -14.638,-1.111 -4.082,-0.406 -7.245,-0.705 -11.518,-0.812 -4.275,-0.107 -9.66,-0.021 -13.378,-0.513 -3.719,-0.491 -5.77,-1.56 -7.287,-3.504 -1.518,-1.945 -2.501,-4.766 -2.885,-7.992 -0.385,-3.227 -0.172,-6.86 0.384,-9.745 0.556,-2.885 1.454,-5.022 2.565,-7.459zm69.969 25.109c0.519,7.153 0.663,14.449 0.431,21.89 -0.846,30.412 -9.714,56.228 -26.604,77.449 -12.544,14.585 -19.831,11.404 -14.873,-8.206 4.903,-19.392 10.706,-34.706 8.269,-48.53 -1.911,-10.84 -4.998,-10.312 -8.622,-1.571 -3.397,8.197 -3.746,21.436 -6.347,41.479 -2.205,16.992 -13.812,25.223 -16.411,11.795 -6.226,-32.166 -4.425,-59.327 -4.515,-92.835"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M38.554 66.372c-9.945,20.709 -14.24,44.686 -12.887,71.932 -5.957,-36.748 -3.136,-61.366 8.463,-73.854 1.113,0.557 2.357,0.985 4.424,1.922z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M67.12 69.857c1.941,22.89 -2.558,46.83 -13.499,71.82 18.619,-32.238 24.724,-56.253 18.317,-72.046 -1.239,0.126 -2.554,0.084 -4.818,0.226z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
